
import { takeEvery } from '@zaibot/fsa-saga';
import 'arrayq';
import { selectors as metaSelectors } from '../../meta/selectors';
import { fork, put, select } from '../../redux-saga';
import { notesSharedBatch, notesSharedEditor, notesSharedResource } from './resource';
import AUTHENTICATED from '../../auth/actions/AUTHENTICATED';
import { SelectEffect } from 'redux-saga/effects';
import USERGROUP_CREATED from '../../usergroup/actions/USERGROUP_CREATED';
import USERGROUP_UPDATED from '../../usergroup/actions/USERGROUP_UPDATED';
import { beheerResource } from '../../admin/resource';

export function* rootSaga(): Iterable<any> {
    yield fork(notesSharedResource.saga);
    yield fork(notesSharedEditor.saga);
    yield fork(notesSharedBatch.saga);
    yield fork(signalNotesSharedListRead);
    yield fork(signalNotesSharedList);
}

function* signalNotesSharedList() {
    yield takeEvery(AUTHENTICATED, function*() {
        let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
        let selectionDocumentId: any = selectionDocument;
        yield put(notesSharedResource.actions.LIST({ params: { selectionDocumentId } }));
    });
    yield takeEvery([USERGROUP_CREATED, 
        USERGROUP_UPDATED], function*() {
        let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
        let selectionDocumentId: any = selectionDocument;
        const documentId = selectionDocumentId;
        yield put(notesSharedResource.actions.LIST({ params: { documentId } }));
    });     
    yield takeEvery([beheerResource.actions.CREATE_SUCCESS, 
        beheerResource.actions.UPDATE_SUCCESS], function*() {
        let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
        let selectionDocumentId: any = selectionDocument;
        const documentId = selectionDocumentId;
        yield put(notesSharedResource.actions.LIST({ params: { documentId } }));
    });    
}

function* signalNotesSharedListRead() {
    yield takeEvery(notesSharedResource.actions.LIST_SUCCESS, function*() {
        yield select(notesSharedResource.selectors.items);
    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/noteshared/sagas.tsx